export default {
  rating: '<span class="font-600">{amount}</span> 5-star ratings <span class="m-0 mx-5px">&#124;</span><span class="font-600"> {downloads}</span> downloads'
}
